import React from 'react';

import ValueBanner from 'dpl/common/components/ValueBanner';

import SearchSection from './SearchSection';
import OwnerStoriesSection from './OwnerStoriesSection';
import AppReviewsBanner from './AppReviewsBanner';
import FaqsSection from './FaqsSection';
import PopularBreedsModule from './PopularBreedsModule';
import NewsModule from './NewsModule';
import CertifiedBreedersModule from './CertifiedBreedersModule';

export default function ReviewsLayout() {
  return (
    <div className="ReviewsLayout mb4">
      <SearchSection />
      <OwnerStoriesSection />
      <AppReviewsBanner />
      <CertifiedBreedersModule />
      <NewsModule />
      <ValueBanner />
      <FaqsSection />
      <PopularBreedsModule />
    </div>
  );
}
